{% block ecocode_trustpilot_invitation_template_select %}
    <div class="ecocode-trustpilot-invitation-template-select__block">
        <sw-single-select
                deprecated
                :options="options"
                :isLoading="isLoading"
                :label="label"
                :name="locale"
                :disabled="disabled"
                required
                v-model:value="currentValue"
        />
    </div>
{% endblock %}
